'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var NAME = exports.NAME = 'customer';

// ACTION TYPES
var actionTypes = exports.actionTypes = {
  FETCH_CUSTOMER: NAME + '/FETCH_CUSTOMER',
  FETCH_CUSTOMER_PREFS: NAME + '/FETCH_CUSTOMER_PREFS',
  FETCH_POLICY_DOC: NAME + '/FETCH_POLICY_DOC'
};
var contactPrefsFormIds = exports.contactPrefsFormIds = {
  contact: 'marketingContactPrefs',
  interests: 'marketingInterestsPrefs'
};
var contactPrefsFieldName = exports.contactPrefsFieldName = 'prefs';
var API_BASE_URI = exports.API_BASE_URI = process.env.REACT_APP_API_BASE_URI + '/ldi/v1';
var customerUrl = exports.customerUrl = API_BASE_URI + '/policy';
var marketingPrefs = exports.marketingPrefs = function marketingPrefs(type) {
  var base = process.env.REACT_APP_API_BASE_URI + '/shared/v1/marketing-preferences';
  if (type === contactPrefsFormIds.contact) {
    return base + '/contact';
  }
  if (type === contactPrefsFormIds.interests) {
    return base + '/interest';
  }
  return base;
};
var marketingOptions = exports.marketingOptions = {
  interests: [{
    value: 'interestStories',
    text: 'Stories from young drivers'
  }, {
    value: 'interestCompetitions',
    text: 'Competitions'
  }, {
    value: 'interestSurveys',
    text: 'Surveys'
  }, {
    value: 'interestNewCars',
    text: 'New cars'
  }, {
    value: 'interestAdvice',
    text: 'Advice articles'
  }, {
    value: 'interestCarMaintenance',
    text: 'Car maintenance'
  }],
  contact: [{
    value: 'allowEmail',
    text: 'Email'
  }, {
    value: 'allowSocialMedia',
    text: 'Social media'
  }, {
    value: 'allowDigitalMedia',
    text: 'Digital media'
  }, {
    value: 'allowSms',
    text: 'Text message'
  }, {
    value: 'allowSnailMail',
    text: 'Post'
  }, {
    value: 'allowPushNotifications',
    text: 'Push notifications'
  }]
};
var policyTypes = exports.policyTypes = ['live', 'future', 'history', 'quotes'];